//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormBuilder.module.css"

export default function ElementModel({ element }) {
  return (
    <div
      className={`${myStyles.elementItemLayoutContainer} tt-element`}
      data-pr-tooltip={element.tooltip || element.label}
      data-pr-position="bottom"
    >
      <div className={myStyles.elementItemLayout}>
        <div className={myStyles.elementItemLayoutIcon}>
          <span
            className={element.iconClass ? element.iconClass : `material-icons`}
          >
            {element.icon}
          </span>
        </div>
        <div className={myStyles.elementItemLayoutText}>{element.label}</div>
        <div className={myStyles.elementItemLayoutGrid}>
          <span className={`material-icons`}>{"drag_indicator"}</span>
        </div>
      </div>
    </div>
  )
}
